export default __webpack_public_path__ + "static/media/ff_en_2.4def63f5.png";